// Phường Thị P0 (UI_SPEC §18.5): sạp mua / bán nguyên liệu cơ bản, giá cố định. Giá thu mua lại
// = 0,4 × giá bán (DECISIONS: chặn vòng arbitrage).
export const MARKET_BUYBACK = 0.4;

export interface MarketEntry {
  /** Id vật phẩm xếp chồng hoặc tiền tệ ví. */
  readonly id: string;
  /** Giá mua của người chơi (linh thạch); null = sạp không bán. */
  readonly buy: number | null;
  /** Giá sạp thu (linh thạch); mặc định floor(buy × 0,4). */
  readonly sell?: number;
}

export const MARKET: readonly MarketEntry[] = [
  { id: 'seed.dewGrass', buy: 10 },
  { id: 'seed.yellowEssence', buy: 40 },
  { id: 'mat.springWater', buy: 30 },
  { id: 'mat.beastCore1', buy: 150 },
  { id: 'mat.spiritWood', buy: 25 },
  { id: 'mat.darkIronSand', buy: 40 },
  { id: 'refiningStone', buy: 60 },
  { id: 'herb.dewGrass', buy: null, sell: 3 },
  { id: 'herb.yellowEssence', buy: null, sell: 12 },
  { id: 'mat.wolfFang', buy: null, sell: 4 },
  { id: 'mat.wolfPelt', buy: null, sell: 4 },
  { id: 'mat.tigerBone', buy: null, sell: 5 },
  { id: 'mat.tigerPelt', buy: null, sell: 5 },
  { id: 'mat.bloodFang', buy: null, sell: 30 },
  { id: 'mat.tigerClaw', buy: null, sell: 30 },
];

export function sellPrice(e: MarketEntry): number {
  return e.sell ?? Math.floor((e.buy ?? 0) * MARKET_BUYBACK);
}
